module.exports = __webpack_public_path__ + "static/media/img_feature_photo2@3x.38fd6ebe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_feature_photo2@3x.jpg
// module id = 799
// module chunks = 0